export const RETAILER_LIST = [
    {
        id: 1,
        step: 'Create Profile',
        dbName: 'companyDetail',
        stepUrl: '/account-setup/create-profile'
    },
    { id: 2, step: 'FAQ', dbName: 'faq', stepUrl: '/account-setup/faq' },
    { id: 3, step: 'Widgets', dbName: 'widget', stepUrl: '/account-setup/widgets' },
    { id: 4, step: 'Integration', dbName: 'integration', stepUrl: '/account-setup/integration' }
];

export const HOSPITALITY_LIST = [
    {
        id: 1,
        step: 'Create Profile',
        dbName: 'companyDetail',
        stepUrl: '/account-setup/create-profile'
    },
    {
        id: 2,
        step: 'Actions',
        dbName: 'menu',
        stepUrl: '/account-setup/create-menu'
    },
    {
        id: 3,
        step: 'Catalouge',
        dbName: 'foodItem',
        stepUrl: '/account-setup/create-product'
    },
    { id: 4, step: 'FAQ', dbName: 'faq', stepUrl: '/account-setup/faq' },
    { id: 5, step: 'Widgets', dbName: 'widget', stepUrl: '/account-setup/widgets' },
    { id: 6, step: 'Integration', dbName: 'integration', stepUrl: '/account-setup/integration' }
];

export const OTHER_LIST = [
    {
        id: 1,
        step: 'Create Profile',
        dbName: 'companyDetail',
        stepUrl: '/account-setup/create-profile'
    },
    {
        id: 2,
        step: 'Actions',
        dbName: 'menu',
        stepUrl: '/account-setup/create-menu'
    },
    { id: 3, step: 'FAQ', dbName: 'faq', stepUrl: '/account-setup/faq' },
    { id: 4, step: 'Widgets', dbName: 'widget', stepUrl: '/account-setup/widgets' },
    { id: 5, step: 'Integration', dbName: 'integration', stepUrl: '/account-setup/integration' }

];

export const MENU_LIST = ['Booking', 'Services', 'Enquiry', 'Complaint', 'Feedback', 'Check-In', 'FAQ', 'Chat With Agent']

export const OTHER_MENU_LIST = ['Feedback', 'Enquiry', 'Complaint', 'FAQ', 'Chat With Agent']
